import { heading, tableData } from "../../../services/requestsTableData";
import { useState } from "react";
import BasicModal from "../../../components/models/models";
import Table from "../../../components/Table/table";
import Header from "../../../components/Headers/Header";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  getRequestsPage,
  selectPersonalDashboard,
  updatedPersonalRequests,
  getRequestsPagewithoutParams,
} from "../../../redux/slices/personalDashboardSlice";
import {
  selectCompanyDashboard,
} from "../../../redux/slices/companyDashboardSlice";
import { useEffect } from "react";
import Button from "../../../components/Buttons/button";
const initialState = {
  status: false,
  requestType: false,
  service: false,
  Comments: false,
  requested_on: false,
  request_reason: false,
};
function RequestModule({ show, setShow }) {
  const location = useLocation();
  const { openPopup, locationSetId } = location.state || {};
  const [isLoader, setIsLoader] = useState(false);
  const [popup, setPopup] = useState(false);
  const [state, setState] = useState(0);
  const [id, setId] = useState({});
  const [btns, setBtns] = useState(initialState);
  const [orderType, setOrderType] = useState("asc");
  const dispatch = useDispatch();
  const [active, setActive] = useState("requestType");
  const [requests, setRequests] = useState();
  const State = useSelector(selectPersonalDashboard);
  const CompanyState = useSelector(selectCompanyDashboard);
  const { requestsData } = State;
  const { updateStatusRequest } = CompanyState;
  const transformedData = transformResponse(requestsData?.requests);

  useEffect(() => {
    dispatch(getRequestsPagewithoutParams());
    setIsLoader(true);
  }, [openPopup, updateStatusRequest]);

  useEffect(() => {
    if (openPopup && isLoader) {
      setPopup(true);
      setState(25);
      setId({ id: locationSetId.id, userId: locationSetId.userId });
    }
  }, [openPopup, isLoader, locationSetId]);

  const handleService = (orderType, set) => {
    setBtns({
      ...btns,
      user: true,
      [active !== "user" && active]: false,
    });
    setActive("user");
    let sort = null;
    if (orderType === "asc") {
      sort = [...requestsData?.requests].sort((a, b) =>
        a.service_name.localeCompare(b.service_name)
      );
    } else {
      sort = [...requestsData?.requests].sort((a, b) =>
        b.service_name.localeCompare(a.service_name)
      );
    }
    dispatch(updatedPersonalRequests(sort));
    setOrderType(orderType == "asc" ? "desc" : "asc");
  };

  const handleRequestType = (orderType, set) => {
    setBtns({
      ...btns,
      requestType: true,
      [active !== "requestType" && active]: false,
    });
    setActive("requestType");
    let sort = null;
    if (orderType === "asc") {
      sort = [...requestsData?.requests].sort((a, b) =>
        a.request_type.localeCompare(b.request_type)
      );
    } else {
      sort = [...requestsData?.requests].sort((a, b) =>
        b.request_type.localeCompare(a.request_type)
      );
    }
    dispatch(updatedPersonalRequests(sort));
    setOrderType(orderType == "asc" ? "desc" : "asc");
  };

  const handleStatus = (orderType) => {
    setBtns({
      ...btns,
      status: true,
      // upDown: set ? !btns.upDown : false,
      [active !== "status" && active]: false,
    });
    setActive("status");
    let sort = null;
    if (orderType === "asc") {
      sort = [...requestsData?.requests].sort((a, b) =>
        a.status.localeCompare(b.status)
      );
    } else {
      sort = [...requestsData?.requests].sort((a, b) =>
        b.status.localeCompare(a.status)
      );
    }
    dispatch(updatedPersonalRequests(sort));
    setOrderType(orderType == "asc" ? "desc" : "asc");
  };

  const handleRequestReason = (orderType) => {
    setBtns({
      ...btns,
      service: true,
      [active !== "request_reason" && active]: false,
    });
    setActive("request_reason");
    let sort = null;
    if (orderType === "asc") {
      sort = [...requestsData?.requests].sort((a, b) =>
        a.request_reason.localeCompare(b.request_reason)
      );
    } else {
      sort = [...requestsData?.requests].sort((a, b) =>
        b.request_reason.localeCompare(a.request_reason)
      );
    }
    dispatch(updatedPersonalRequests(sort));
    setOrderType(orderType == "asc" ? "desc" : "asc");
  };

  const handleComment = (orderType) => {
    setBtns({
      ...btns,
      Comments: true,
      [active !== "Comments" && active]: false,
    });
    setActive("Comments");
    let sort = null;
    if (orderType === "asc") {
      sort = [...requestsData.requests].sort(
        (a, b) => a.comments_count - b.comments_count
      );
    } else {
      sort = [...requestsData.requests].sort(
        (a, b) => b.comments_count - a.comments_count
      );
    }
    dispatch(updatedPersonalRequests(sort));
    setOrderType(orderType == "asc" ? "desc" : "asc");
  };

  const parseDate = (dateString) => {
    const [day, month, year] = dateString.split("/");
    return new Date(`${year}-${month}-${day}`);
  };

  const handleRequestDate = (orderType) => {
    setBtns({
      ...btns,
      requested_on: true,
      // upDown: set ? !btns.upDown : false,
      [active !== "requested_on" && active]: false,
    });
    setActive("requested_on");
    const sort = [...requestsData.requests].sort((a, b) => {
      const dateA = parseDate(a.requested_on);
      const dateB = parseDate(b.requested_on);

      if (orderType === "asc") {
        return dateB - dateA;
      } else {
        return dateA - dateB;
      }
    });
    dispatch(updatedPersonalRequests(sort));
    setOrderType(orderType == "asc" ? "desc" : "asc");
  };

  function transformResponse(response) {
    if (response === undefined) {
      return undefined;
    } else {
      return response.map((item) => {
        return {
          id: item.id,
          userId: item.user_id,
          serviceId: item.service_id,
          service: {
            image: item.service.image_url,
            name: item.service.name,
            category: item.service.category_name,
          },
          type: item.request_type,
          status: item.status,
          reason: {
            heading: item.request_reason,
            subHeading: item.description,
          },
          comment: item.comments_count == 0 ? "-" : item.comments_count,
          date: item.requested_on,
        };
      });
    }
  }

  return (
    <div className="right_panel flex flex-col w-[100%] gap-[42px] pt-[20px] xl:pt-[32px] xl:max-w-[1099px] 6xl:max-w-[80%] pr-[24px]">
      <Header
        title={"Your Service Requests"}
        subHeading={
          "Suggestions you've made for the services you use. (Sort by request date)"
        }
        show={show}
        setShow={setShow}
        btns={false}
      />

      {/*><div className="flex gap-[12px] h-[54px] overflow-scroll scrollbar-hide items-center">
  
        <Button
          onClick={() => {
            handleRequestType("asc", false);
          }}
          hoverOutlined={!btns.requestType}
          outlined={btns.requestType}
          secondaryHoverOutlined={true}
          className="max-xs:min-w-[150px] sm:min-w-[150px]"
        >
          Request Type
        </Button>
    
        <Button
          onClick={() => {
            handleStatus("asc", false);
          }}
          hoverOutlined={!btns.status}
          outlined={btns.status}
          className="max-xs:min-w-[150px] sm:min-w-[150px]"
          secondaryHoverOutlined={true}
        >
          Status
        </Button>
         
        <Button
          onClick={ handleUpdown }
          hoverOutlined={ !btns.upDown }
          className="max-xs:min-w-[150px] sm:min-w-[150px]"
          outlined={ btns.upDown }
          secondaryHoverOutlined={ true }
        >
          <div className="pt-[4px] pl-[6px] pb-[4px] pr-[6px]">
            <svg
              width="16"
              height="14"
              viewBox="0 0 16 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.23466 0.207432L4.27333 0.202671L4.33333 0.199951L4.38333 0.201991L4.46734 0.213552L4.54134 0.233953L4.61534 0.263874L4.68067 0.299236L4.75001 0.349558L4.80468 0.399201L8.47142 4.13939C8.59099 4.26177 8.66041 4.42598 8.66558 4.59867C8.67075 4.77137 8.61128 4.93959 8.49926 5.06918C8.38723 5.19877 8.23105 5.28001 8.06243 5.2964C7.89381 5.31278 7.7254 5.26308 7.5914 5.1574L7.52873 5.10096L5.00001 2.52227V13.1206C4.99983 13.2939 4.93476 13.4606 4.81811 13.5867C4.70146 13.7127 4.54203 13.7885 4.3724 13.7987C4.20277 13.8089 4.03574 13.7526 3.90544 13.6413C3.77513 13.5301 3.69139 13.3723 3.67132 13.2002L3.66665 13.1206V2.52227L1.13793 5.10096C1.02313 5.21804 0.870397 5.28838 0.708377 5.29877C0.546356 5.30916 0.386185 5.25889 0.257913 5.1574L0.195245 5.10096C0.0804581 4.98386 0.0115025 4.82806 0.00131483 4.6628C-0.00887284 4.49753 0.0404075 4.33415 0.13991 4.20331L0.195245 4.13939L3.86199 0.399201C3.88526 0.375378 3.91022 0.353331 3.93666 0.333238L4.00999 0.284955L4.08599 0.248234L4.156 0.224432L4.23466 0.207432ZM11.6668 0.199951C11.8301 0.199973 11.9877 0.261124 12.1097 0.371806C12.2318 0.482488 12.3097 0.635002 12.3288 0.800421L12.3335 0.879985V11.4783L14.8622 8.89962L14.9249 8.84318C15.0532 8.74176 15.2133 8.69155 15.3753 8.70198C15.5373 8.7124 15.69 8.78274 15.8047 8.8998C15.9195 9.01687 15.9885 9.17262 15.9987 9.33784C16.0089 9.50307 15.9597 9.66642 15.8602 9.79727L15.8049 9.86119L12.1382 13.6014L12.1088 13.6293L12.0635 13.6673L11.9902 13.7156L11.9142 13.7523L11.8442 13.7761L11.7662 13.7931L11.7062 13.7999H11.6275L11.5875 13.7959L11.5115 13.7823L11.4388 13.7598L11.3848 13.7367L11.3195 13.7013L11.2555 13.6558C11.2344 13.6389 11.2144 13.6207 11.1955 13.6014L7.52873 9.86119L7.4734 9.79727C7.38269 9.67801 7.33345 9.53135 7.33345 9.38041C7.33345 9.22946 7.38269 9.08281 7.4734 8.96355L7.52873 8.89962L7.5914 8.84318C7.70832 8.75065 7.8521 8.70043 8.00008 8.70043C8.14806 8.70043 8.29183 8.75065 8.40875 8.84318L8.47142 8.89962L11.0001 11.4783V0.879985L11.0048 0.800421C11.0239 0.635002 11.1019 0.482488 11.2239 0.371806C11.3459 0.261124 11.5035 0.199973 11.6668 0.199951Z"
                fill="white"
              />
            </svg>
          </div>
        </Button>
      </div>*/}

      <div className="card-section">
        <div className="cards_wrap bottom_space bg-[#363D50] w-[100%] rounded-[24px] overflow-y-scroll scrollbar-hide max-h-[470px] md:max-h-[670px]">
          <Table
            setState={setState}
            setId={setId}
            setPopup={setPopup}
            headings={heading}
            tableData={transformedData}
            table={"request"}
            handleStatus={handleStatus}
            handleRequestType={handleRequestType}
            handleRequestDate={handleRequestDate}
            handleComment={handleComment}
            handleService={handleService}
            handleRequestReason={handleRequestReason}
            orderType={orderType}
          />
        </div>
      </div>

      {popup && (
        <BasicModal
          id={id}
          setId={setId}
          state={state}
          popup={popup}
          setPopup={setPopup}
          setState={setState}
        />
      )}
    </div>
  );
}

export default RequestModule;
